<template>
    <status-badge :label="label" :icon="icon" :color-class="colorClass" />
</template>

<script>
  import StatusBadge from './StatusBadge'
  export default {
    name: 'InvoiceStatusBadge',
    components: {StatusBadge},
    props: {
      status: Number
    },
    computed: {
      label() {
        switch (this.status) {
          case 0: return 'Invoices.statusReceived';
          case 1: return 'Invoices.statusOpen';
          case 2: return 'Invoices.statusHold';
          case 3: return 'Invoices.statusCancelled';
          case 4: return 'Invoices.statusClosed';
          case 17: return 'Invoices.statusPartlyPaid';
          case 18: return 'Invoices.statusPartlyPaidCancelled';
          case 19: return 'Invoices.statusPartlyPaidClosed';
          case 20: return 'Invoices.statusPaid';
          default: return 'Unknown: ' + this.status;
        }
      },
      icon() {
        switch (this.status) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4: return 'fa fa-times';
          case 17:
          case 18:
          case 19:
          case 20: return 'fa fa-money';
          default: return 'fa fa-unknown';
        }
      },
      labelClass() {
        switch (status) {
          case 0:
          case 1:
          case 2: return 'warning';
          case 4:
          case 19: return 'info';
          case 3:
          case 18: return 'danger';
          case 17:
          case 20: return 'success';
          default: return 'unknown';
        }
      }
    }
  }
</script>

<style scoped>

</style>
